import Utils from './../../../app/utils';
import localTranslationJson from '../../../../translation.json'

const { setLocalStorage, getCookie } = Utils;

const mergeTranslationJson = ({ localTranslationJson = {}, collectionTranslationJson= {}, language = 'IN_en' }) => {
    const translationsMapper = {};
    for (const key in localTranslationJson) {
        translationsMapper[`${key}_${language}`] = localTranslationJson[key][language] || localTranslationJson[key].IN_en;
    }
    for (const key in collectionTranslationJson) {
        if(language in collectionTranslationJson[key]) {
            translationsMapper[`${key}_${language}`] = collectionTranslationJson[key][language];
        } else {
            translationsMapper[`${key}_${language}`] = collectionTranslationJson[key].IN_en;
        }
    }
    return translationsMapper;
}


const setTranslations = (payload = {}) => {
    const { response = {} } = payload;
    const { payload: innerPayload = {} } = response;
    const { languageTranslate_Hotel = {} } = innerPayload;
    const ccode = getCookie('ccode') || 'IN';
    const locale = getCookie('locale') || 'en';
    const countryLocaleTag = `${ccode}_${locale}`;
    const data = mergeTranslationJson({ localTranslationJson: localTranslationJson, collectionTranslationJson: languageTranslate_Hotel, language: countryLocaleTag })
    setLocalStorage(`languageTranslate_${ccode}_${locale}`, data);
};

export default setTranslations;
